import script from "./RankTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./RankTable.vue?vue&type=script&lang=ts&setup=true"

import "./RankTable.vue?vue&type=style&index=0&id=0e8869e7&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e8869e7"]])

export default __exports__